import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../config/apiClient";
import API_ENDPOINTS from "../config/api";

const initialState = {
  results:       [],
  loading:       false,
  error:         null,
  keyword:       "",
  current_page:  1,
  total_pages:   0,
  total:         0,
};

export const fetchSearchResults = createAsyncThunk(
  "search/fetchSearchResults",
  async ({ keyword, page = 1 }, { rejectWithValue }) => {
    try {
      const res = await apiClient.get(
        `${API_ENDPOINTS.SEARCH}?keyword=${encodeURIComponent(keyword)}&page=${page}&limit=20`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    clearSearch: (state) => {
      state.results      = [];
      state.keyword      = "";
      state.total        = 0;
      state.total_pages  = 0;
      state.current_page = 1;
      state.error        = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSearchResults.pending, (state) => {
        state.loading = true;
        state.error   = null;
      })
      .addCase(fetchSearchResults.fulfilled, (state, action) => {
        state.loading      = false;
        state.results      = action.payload.data;
        state.keyword      = action.payload.keyword;
        state.current_page = action.payload.current_page;
        state.total_pages  = action.payload.total_pages;
        state.total        = action.payload.total;
      })
      .addCase(fetchSearchResults.rejected, (state, action) => {
        state.loading = false;
        state.error   = action.payload;
      });
  },
});

export const { clearSearch } = searchSlice.actions;
export default searchSlice.reducer;